export default __webpack_public_path__ + "0d917d8e1c3224a17327ee951540988c.png";